// extracted by mini-css-extract-plugin
module.exports = {"root":"IconIncreaseSize_root__1ykY_"};